module.exports = __webpack_public_path__ + "static/media/whatsapp_icon.272493b3.svg";